'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import * as React from 'react'

import { getPageTypeAndSlug, testMobileDevice } from '@/lib/utils'
import {
  // useCurrentPageType,
  useGlobalStateActions,
  useTunnel,
  // usePreviousPageType,
} from '@/state/useGlobalState'

export default function GlobalState() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  // Update current page in store
  // Close menu when route changes
  const {
    setCurrentPage,
    setPathname,
    toggleMenuOpen,
    setIsMobile,
    setIsDevice,
  } = useGlobalStateActions()
  React.useEffect(() => {
    const { pageSlug, pageType } = getPageTypeAndSlug(pathname)
    // const url = `${pathname}?${searchParams}`
    // console.log('pageType', pageType)
    // console.log('pathname', pathname)
    // console.log('searchParams', searchParams)
    // console.log(url)
    setPathname(pathname)
    setCurrentPage(pageSlug, pageType)
    toggleMenuOpen(false)
  }, [pathname, searchParams, setCurrentPage, setPathname, toggleMenuOpen])

  // TEST FOR MOBILE
  React.useEffect(() => {
    const isMobile = testMobileDevice()
    const isDevice = testMobileDevice(true)
    setIsMobile(isMobile)
    setIsDevice(isDevice)
  }, [setIsMobile, setIsDevice])

  const tunnel = useTunnel()

  // // * DEBUGGING
  // const currentPage = useCurrentPageType()
  // const previousPage = usePreviousPageType()
  // React.useEffect(() => {
  //   console.log('currentPage', currentPage)
  //   console.log('previousPage', previousPage)
  //   console.log('****')
  // }, [currentPage, previousPage])

  return <tunnel.Out />
}
